import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import * as moment from 'moment';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import { CustomFieldPayload } from './custom-field-form.interface';
import _ from 'lodash';
import { ReplaySubject } from 'rxjs';

dayjs.extend(utc);

@Injectable({
  providedIn: 'root'
})
export class CustomFieldService {

  payloadArray: any = [];
  quickCreateArray: any = {};
  formBuilderSubscription: ReplaySubject<any> = new ReplaySubject<any>(1);
  constructor(
    private _dataCollectorService: DataCollectorService,
    private _utilityService: UtilityService
  ) { }

  getCustomFields(): string {
    return this._dataCollectorService.baseurl() + '/settings/custom_fields';
  }

  //To construct object to be sent as payload
  constructCustomFields(group: UntypedFormGroup,isQuickCreate?: any, module?:any): CustomFieldPayload[] {
    let actualPayloadArray = isQuickCreate === true ? _.cloneDeep(this.quickCreateArray[module]) : _.cloneDeep(this.payloadArray);
    actualPayloadArray = actualPayloadArray.filter((payload: any) => {
      let shouldIncludeField = true;
      if (payload?.dependent_on && payload?.dependent_options?.length > 0) {
        shouldIncludeField = true;
        payload.dependent_options.forEach((option: string) => {
          const groupName = payload?.group_name ? payload?.group_name :'DEFAULT';
          const controlValue = group.controls[groupName + '_' + payload?.dependent_on]?.value;
          if (typeof controlValue === 'string') {
            if (controlValue !== option.trim()) {
              shouldIncludeField = false;
            }
          } else if (typeof controlValue === 'object') {
            if ((!controlValue || !controlValue?.[option.trim()])) {
              shouldIncludeField = false;
            }
          } else {
            shouldIncludeField = false;
          }
        });
      }
      return shouldIncludeField;
    });
    if(!this._utilityService.isEmptyOrUndefined(actualPayloadArray)){
      actualPayloadArray.forEach((payload: any) => {
        //Custom fields with group name
        if(payload?.group_name){
          if(payload?.type === 'MULTI_ITEM'){
            const checkboxArray = [];
            if(group.controls[payload?.group_name+'_'+payload?.label]?.['value']){
              const checkboxGroupArray = Object.entries(group.controls[payload?.group_name+'_'+payload?.label]?.['value']);
              if(checkboxGroupArray?.length > 0){
                for(const key in group.controls[payload?.group_name+'_'+payload?.label]?.['value']){
                  if(group.controls[payload?.group_name+'_'+payload?.label].value[key]){
                    checkboxArray.push(key);
                  }
                }
                payload.value = checkboxArray.join(',');
              }
            }
          }
          else if(payload?.type === 'DATE'){
            if(group.controls[payload?.group_name+'_'+payload?.label]?.['value']){
              payload.value = moment(group.controls[payload?.group_name+'_'+payload?.label].value).format('YYYY-MM-DD');
            }else if(!payload?.value){
              payload.value = '';
            }
          }
          else if(payload?.type === 'TIME'){
            if(group.controls[payload?.group_name+'_'+payload?.label]?.value){
              payload.value = moment(group.controls[payload?.group_name+'_'+payload?.label].value, this._utilityService.timeFormat).format('HH:mm:ss');
            }else if(!payload?.value){
              payload.value = '';
            }
          }
          else if(payload?.type === 'DATETIME'){
            if(group.controls[payload?.group_name+'_'+payload?.label]?.value){
              const dateTime = moment(group.controls[payload?.group_name+'_'+payload?.label].value).format('YYYY-MM-DD HH:mm:ss');
              payload.value = dayjs(dateTime,'YYYY-MM-DD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss');
            }else if(!payload?.value){
              payload.value = '';
            }
          }
          else{
            if(group.controls[payload?.group_name+'_'+payload?.label]?.value){
              payload.value = group.controls[payload?.group_name+'_'+payload?.label]?.value;
            }else if(!payload?.value){
              payload.value = '';
            }
          }
        }
        //Custom fields without group name
        else
        {
          if(payload?.type === 'MULTI_ITEM'){
            const checkboxArray = [];
            if(group.controls['DEFAULT_'+payload?.label]?.['value']){
              const checkboxGroupArray = Object.entries(group.controls['DEFAULT_'+payload?.label]?.['value']);
              if(checkboxGroupArray?.length > 0){
                for(const key in group.controls['DEFAULT_'+payload?.label]?.['value']){
                  if(group.controls['DEFAULT_'+payload?.label].value[key]){
                    checkboxArray.push(key);
                  }
                }
                payload.value = checkboxArray.join(',');
              }
            }
            payload.value = checkboxArray.join(',');
          }
          else if(payload?.type === 'DATE'){
            if(group.controls['DEFAULT_'+payload?.label]?.value){
              payload.value = moment(group.controls['DEFAULT_'+payload?.label].value).format('YYYY-MM-DD');
            }else if(!payload?.value){
              payload.value = '';
            }
          }
          else if(payload?.type === 'TIME'){
            if(group.controls['DEFAULT_'+payload?.label]?.value){
              payload.value = moment(group.controls['DEFAULT_'+payload?.label].value, this._utilityService.timeFormat).format('HH:mm:ss');
            }else if(!payload?.value){
              payload.value = '';
            }
          }
          else if(payload?.type === 'DATETIME'){
            if(group.controls['DEFAULT_'+payload?.label]?.value){
              const dateTime = moment(group.controls['DEFAULT_'+payload?.label].value).format('YYYY-MM-DD HH:mm:ss');
              payload.value = dayjs(dateTime,'YYYY-MM-DD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss');
            }else if(!payload?.value){
              payload.value = '';
            }
          }
          else{
            if(group.controls['DEFAULT_'+payload?.label]?.value){
              payload.value = group.controls['DEFAULT_'+payload?.label]?.value;
            }else if(!payload?.value){
              payload.value = '';
            }
          }
        }
      });
    }

    const groupValue = [];
    const defaultGroup = [];
    const historyRecords = [];
    actualPayloadArray.forEach((field: any) => {
      if (
        !this._utilityService.isEmptyOrUndefined(field?.group_uid) &&
        (field?.group?.group_name !== 'default_group' ||
          field?.group_name !== 'default_group')
      ) {
        groupValue.push(field);
      }
      if (
        this._utilityService.isEmptyOrUndefined(field?.group_uid) &&
        (field?.group?.group_name === 'default_group' ||
          field?.group_name === 'default_group')
      ) {
        defaultGroup.push(field);
      }
      if (
        this._utilityService.isEmptyOrUndefined(field?.group_uid) &&
        this._utilityService.isEmptyOrUndefined(field?.group)
      ) {
        historyRecords.push(field);
      }
    });
    const responseArray = [...historyRecords,...defaultGroup,...groupValue];
    return responseArray;
  }
}
